{
  "locale": "Español",
  "sidebar": {
    "title": "Solicitud de intercambio de datos",
    "issuanceTitle": "Solicitud para añadir datos",
    "authenticationTitle": "Solicitud de autenticación",
    "description": "{clientName} solicita datos personales verificados de su aplicación de identidad. Revise los detalles a continuación y apruebe o rechace esta solicitud en su aplicación de identidad.",
    "issuanceDescription": "{clientName} está añadiendo datos verificados a su aplicación de identidad. Revise los detalles a continuación y confirme en su aplicación de identidad si desea aceptarlos.",
    "authenticationDescription": "{clientName} quiere autenticarse con su aplicación de identidad.",
    "descriptionFallback": "Un servicio solicita datos personales verificados de su aplicación de identidad. Revise los detalles a continuación y apruebe o rechace esta solicitud en su aplicación de identidad.",
    "issuanceDescriptionFallback": "Un servicio está añadiendo datos verificados a su aplicación de identidad. Revise los detalles a continuación y confirme en su aplicación de identidad si desea aceptarlos.",
    "authenticationDescriptionFallback": "Un servicio quiere autenticarse con su aplicación de identidad.",
    "stepsTitle": "Pasos a completar",
    "stepShareData": "Compartir datos con {clientName}",
    "stepAuthenticate": "Autenticarse para {clientName}",
    "stepReceiveData": "Recibir datos de {clientName}",
    "stepGeneric": "Completar los pasos requeridos",
    "defaultClientName": "el servicio",
    "requestedDataTitle": "Se solicitan los siguientes datos",
    "issuedDataTitle": "Se emitirán los siguientes datos",
    "reviewNotice": "Revisará y aprobará los datos exactos en su aplicación de identidad antes de que se comparta nada.",
    "issuanceReviewNotice": "Revisará y aprobará los datos exactos en su aplicación de identidad antes de que se añada nada.",
    "indeterminateHint": "Los datos solicitados serán visibles después de seleccionar una aplicación de identidad",
    "showAll": "Mostrar todo",
    "purposeStatementTitle": "Por qué se necesitan sus datos",
    "retentionPolicyTitle": "Cómo se manejan sus datos"
  },
  "footer": {
    "powered": "Desarrollado por",
    "privacyPolicy": "Política de privacidad"
  },
  "topBar": {
    "openMenu": "Abrir menú",
    "closeMenu": "Cerrar menú",
    "language": "Idioma"
  },
  "app": {
    "loadingTitle": "Cargando"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Buscar",
    "noResults": "Sin resultados"
  },
  "init": {
    "title": "Procesando solicitud",
    "hint": "Preparando tu sesión"
  },
  "pairing": {
    "title": "Preparando el siguiente paso",
    "hint": "Preparando tu sesión",
    "codeLabel": "Verifique el siguiente código en su aplicación de identidad",
    "confirm": "Confirmar emparejamiento"
  },
  "waitingForPresentation": {
    "title": "Continúe en su aplicación de identidad",
    "hint": "Revise su aplicación de identidad para examinar y aprobar la solicitud"
  },
  "agentStart": {
    "title": "Continuar en {appName}",
    "subtitle": "Para compartir sus datos de forma segura, escanee este código QR con {appName} para revisar y aprobar la solicitud.",
    "issuanceSubtitle": "Para recibir los datos de forma segura, escanee este código QR con {appName} para revisar y aprobar la solicitud.",
    "step1": "Abrir {appName}",
    "step2": "Hacer clic en el icono del escáner",
    "step3": "Escanear este código QR",
    "changeApp": "Cambiar aplicación de identidad",
    "installInstructions": "Instrucciones de instalación",
    "cancel": "Cancelar",
    "needHelp": "¿Necesita ayuda?",
    "redirectSubtitle": "Haga clic en el botón de abajo para abrir {appName} y aprobar la solicitud.",
    "issuanceRedirectSubtitle": "Haga clic en el botón de abajo para abrir {appName} y aprobar la solicitud.",
    "redirectButton": "Continuar",
    "mobileSubtitle": "Para compartir sus datos de forma segura, continúe en {appName} para revisar y aprobar la solicitud.",
    "issuanceMobileSubtitle": "Para recibir los datos de forma segura, continúe en {appName} para revisar y aprobar la solicitud.",
    "openApp": "Abrir {appName}",
    "showQr": "Mostrar código QR"
  },
  "done": {
    "disclosure": {
      "title": "Los datos se han compartido con éxito",
      "subtitle": "La página se cerrará automáticamente en unos segundos.",
      "subtitleCloseTab": "Datos compartidos con éxito. Puede cerrar esta página."
    },
    "issuance": {
      "title": "Datos recibidos con éxito",
      "subtitle": "La página se cerrará automáticamente en unos segundos.",
      "subtitleCloseTab": "Datos recibidos con éxito. Puede cerrar esta página."
    },
    "redirecting": "Redirigiendo...",
    "completeRedirect": "Completar y redirigir",
    "redirectFailed": "La redirección automática no funcionó. Toca abajo para continuar."
  },
  "abort": {
    "cancelled": {
      "title": "Proceso detenido",
      "subtitle": "Ha elegido detener el proceso. Puede reiniciar en cualquier momento."
    },
    "serverError": {
      "title": "Algo salió mal",
      "subtitle": "No pudimos completar el proceso debido a un problema técnico."
    },
    "expired": {
      "title": "Sesión expirada",
      "subtitle": "Esta sesión finalizó después de un período de inactividad. Para continuar, cierre esta página y reinicie el proceso."
    },
    "connectionLost": {
      "title": "Conexión perdida",
      "subtitle": "Su conexión a Internet se interrumpió. Verifique su conexión e intente de nuevo."
    },
    "temporarilyUnavailable": {
      "title": "Servicio temporalmente no disponible",
      "subtitle": "El servicio está en mantenimiento actualmente. Intente de nuevo más tarde."
    },
    "appError": {
      "title": "Aplicación de identidad no disponible",
      "subtitle": "No pudimos conectar con la aplicación de identidad seleccionada. La aplicación puede estar temporalmente no disponible. Puede probar con otra aplicación de identidad o intentar de nuevo más tarde."
    },
    "selectDifferentApp": "Seleccionar otra aplicación de identidad",
    "confirmTitle": "¿Detener el proceso?",
    "confirmMessage": "¿Está seguro de que desea detenerse? Puede reiniciar en cualquier momento si desea continuar más tarde.",
    "confirmStop": "Detener proceso",
    "goBack": "Volver",
    "leave": "Salir",
    "restart": "Reiniciar",
    "retry": "Reintentar",
    "contactOrganisation": {
      "subtitle": "No pudimos iniciar el proceso. Póngase en contacto con la organización para obtener ayuda."
    }
  },
  "appPicker": {
    "title": "Aplicaciones de identidad compatibles",
    "subtitle": "Las siguientes aplicaciones de identidad se pueden usar para revisar y aprobar la solicitud",
    "searchPlaceholder": "Buscar...",
    "sectionLastUsed": "Último usado",
    "sectionRecommended": "Recomendado",
    "sectionAZ": "A-Z",
    "noResults": "Ninguna aplicación coincide con su búsqueda",
    "filterTitle": "Filtrar por país",
    "filterClear": "Borrar todo",
    "filterDone": "Hecho"
  },
  "faq": {
    "helpQuestion": "Pregunta",
    "moreHelp": "Más ayuda",
    "close": "Cerrar",
    "whatAreWallets": {
      "title": "¿Qué son las aplicaciones de identidad?",
      "body": "Con una aplicación de identidad, usted controla sus propios datos — usted solo decide qué datos comparte, con quién y cuándo. Sus datos se recuperan de un emisor confiable y verificado y se almacenan en la aplicación junto con una firma digital que garantiza su precisión.\n\nCuando comparte datos con un tercero, la firma digital se incluye para que la parte receptora pueda verificar su autenticidad. Sus datos generalmente se almacenan solo en su propio teléfono y pueden recuperarse fácilmente si es necesario.\n\nTenga en cuenta que es su responsabilidad elegir cuidadosamente con quién comparte sus datos."
    },
    "whyNotSupported": {
      "title": "¿Por qué no se admite mi aplicación de identidad?",
      "body": "Puede suceder que su aplicación de identidad no esté disponible porque la parte receptora o nuestra plataforma no la admite actualmente. Estamos trabajando constantemente para ampliar nuestra gama de aplicaciones compatibles.\n\nSi su aplicación no está en la lista, siempre puede instalar y usar una de las otras aplicaciones de identidad compatibles."
    },
    "howDataProtected": {
      "title": "¿Cómo se protegen mis datos?",
      "body": "Las aplicaciones de identidad garantizan que siempre tenga control sobre con quién comparte sus datos y cuándo. Generalmente le brindan una descripción general de los datos que ha compartido, con quién y cuándo.\n\nVer.iD envía sus datos directamente a la parte receptora y solo verifica que se hayan entregado correctamente.\n\nTenga en cuenta que es su responsabilidad elegir cuidadosamente con quién comparte sus datos.",
      "link": "Más información sobre seguridad y privacidad"
    },
    "howObtainData": {
      "title": "¿Cómo puedo poner datos en mi aplicación?",
      "body": "Cada aplicación de identidad tiene su propia forma de recopilar datos. La mayoría de las aplicaciones tienen un botón para agregar datos. En algunos casos, puede haber costos asociados.\n\nSiga las instrucciones de la aplicación para recopilar sus datos de manera segura. Es posible que se le redirija a sitios web gubernamentales o que deba escanear documentos como pasaportes o licencias de conducir.\n\nSi no ve una forma directa de agregar los datos correctos, consulte la documentación de la aplicación o comuníquese con el proveedor. También puede intentar con otra aplicación de identidad."
    },
    "whyRedirection": {
      "title": "¿Por qué me están redirigiendo?",
      "body": "Algunas aplicaciones de identidad requieren una redirección a su propio sitio web para que sus datos se compartan de acuerdo con sus estándares, en un entorno que usted conoce.\n\nDespués de compartir exitosamente, será redirigido automáticamente a Ver.iD, donde sus datos esperarán su confirmación antes de ser enviados a la parte receptora. Un recibo digital generalmente se encuentra en su aplicación de identidad.\n\nSi el proceso falla o se cancela, también será redirigido y podrá intentarlo de nuevo."
    }
  },
  "mobileFlowStart": {
    "startVerification": "Continuar"
  },
  "requestedDataModal": {
    "title": "Datos solicitados",
    "subtitle": "Revisará y aprobará esta solicitud en su aplicación de identidad.",
    "attribute": "Atributo",
    "description": "Descripción",
    "issuedBy": "Datos emitidos por",
    "close": "Cerrar"
  },
  "demo": {
    "title": "Entorno de demostración",
    "description": "Está usando una demostración interactiva de Ver.iD. Este entorno está destinado únicamente a fines de demostración."
  },
  "installInstructions": {
    "title": "Instalar {appName}",
    "subtitle": "Visite la App Store o Play Store en su teléfono para instalar la aplicación de identidad {appName}. Escanee el código para abrir directamente la página de la tienda e instalar la aplicación.",
    "close": "Cerrar",
    "unavailableTitle": "Instrucciones no disponibles",
    "unavailableBody": "Lo sentimos, no tenemos instrucciones de instalación disponibles para esta aplicación en este momento. Intente buscar manualmente la aplicación en la tienda de aplicaciones para continuar."
  },
  "embedded": {
    "loading": "Cargando aplicaciones de identidad",
    "moreApps": "{count} aplicaciones más",
    "moreAppsOne": "1 aplicación más",
    "useAnotherApp": "Usar otra aplicación",
    "cancel": "Cancelar",
    "back": "Atrás",
    "tryAgain": "Intentar de nuevo",
    "qr": {
      "caption": "Escanea con {bold} para compartir tus datos.",
      "captionIssuance": "Escanea con {bold} para añadir tus datos.",
      "label": "Código QR para escanear con {app}",
      "noApp": "¿No tienes la aplicación {app}?",
      "whatShared": "¿Qué se comparte?",
      "whatAdded": "¿Qué se añade?",
      "expired": "Este código QR ha caducado.",
      "refresh": "Actualizar QR"
    },
    "waiting": {
      "title": "Continúa en {app}",
      "sub": "Aprueba la solicitud en tu teléfono.",
      "subIssuance": "Acepta los datos en tu teléfono.",
      "help": "¿No ves la solicitud?"
    },
    "done": {
      "title": "Compartido con {app}",
      "sub": "Puedes continuar con tu solicitud.",
      "titleIssuance": "Añadido a {app}",
      "subIssuance": "Tus datos ya están en la aplicación."
    },
    "error": {
      "title": "No se completó el envío",
      "sub": "No se ha compartido nada.",
      "titleIssuance": "Tus datos no se añadieron",
      "subIssuance": "No se ha añadido nada a {app}.",
      "help": "¿Por qué no se completó?"
    },
    "unsupported": {
      "title": "{app} aún no se puede usar aquí",
      "sub": "Usa otra aplicación para continuar."
    },
    "install": {
      "caption": "Instala primero {bold}: escanea con la cámara de tu teléfono.",
      "label": "Código QR para descargar {app} de tu tienda de aplicaciones",
      "installed": "Ya la he instalado"
    },
    "missing": {
      "title": "Aún no hay pasos de instalación",
      "sub": "Instala {app} como indica su proveedor y vuelve aquí."
    },
    "notListed": {
      "title": "¿No ves tu aplicación?",
      "sub": "{org} solo acepta estas aplicaciones. Elige una para ver cómo instalarla.",
      "subIssuance": "{org} solo puede añadir datos a estas aplicaciones. Elige una para ver cómo instalarla.",
      "back": "Volver a las aplicaciones"
    },
    "request": {
      "title": "¿No ves la solicitud?",
      "sub": "Mantén {app} abierta, puede tardar unos segundos. ¿Sigue sin aparecer? Vuelve a escanear el código QR.",
      "keepWaiting": "Seguir esperando",
      "scanAgain": "Escanear de nuevo"
    },
    "why": {
      "title": "¿Por qué no se completó?",
      "sub": "Se canceló en {app} o tardó demasiado. No se ha compartido nada.",
      "subIssuance": "Se canceló en {app} o tardó demasiado. No se ha añadido nada."
    },
    "details": {
      "label": "Qué se comparte",
      "caption": "Solicitado por {bold}. Primero lo apruebas en tu aplicación.",
      "back": "Volver al código QR",
      "labelIssuance": "Qué se añade",
      "captionIssuance": "Emitido por {bold}. Primero lo aceptas en tu aplicación.",
      "privacy": "Política de privacidad",
      "security": "¿Cómo se protegen mis datos?"
    },
    "timeout": {
      "title": "Esta solicitud ha caducado",
      "sub": "Las solicitudes siguen abiertas unos minutos. Vuelve a intentarlo para obtener una nueva."
    },
    "launch": {
      "title": "Compartir con {app}",
      "sub": "Toca Abrir {app} para ver y aprobar la solicitud.",
      "titleIssuance": "Añadir a {app}",
      "subIssuance": "Toca Abrir {app} para aceptar los datos.",
      "open": "Abrir {app}"
    },
    "opening": {
      "sub": "Aprueba la solicitud en la aplicación.",
      "subIssuance": "Acepta los datos en la aplicación.",
      "help": "¿No se abrió {app}?"
    },
    "notOpened": {
      "title": "¿No se abrió {app}?",
      "sub": "Puede que {app} no esté instalada en este teléfono. Instálala para continuar.",
      "install": "Instalar {app}"
    },
    "phoneInstall": {
      "title": "¿{app} no está en este teléfono?",
      "sub": "Descárgala de tu tienda de aplicaciones o escanea con otro dispositivo.",
      "get": "Descargar {app}",
      "scanOther": "Escanear con otro dispositivo"
    },
    "phoneQr": {
      "openHere": "Abrir {app} en este teléfono"
    },
    "drawer": {
      "close": "Cerrar",
      "label": "Comparte tus datos con una aplicación de identidad",
      "labelIssuance": "Añade tus datos a una aplicación de identidad"
    }
  }
}
